import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/Auth/authSlice';
import formsReducer from '../features/Forms/slice/formsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    forms: formsReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
